module.exports = __webpack_public_path__ + "static/photos2-d7c9ad530adcc19a318428e6ea3a7263.jpg";